import cx from 'classnames';

export default function GamesLogo({
  className,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 900 230"
      width={900}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={cx('max-w-full', className)}
    >
      <title>Games</title>
      <path
        d="M0 112.573C0 34.855 32.2225 0 87.6796 0C136.633 0 163.893 25.291 166.997 68.7763L119.595 77.7179C117.423 50.5764 108.134 36.0831 87.0655 36.0831C62.5916 36.0831 49.8857 55.2056 49.8857 112.573C49.8857 173.024 61.9663 192.453 87.9922 192.453C110.607 192.453 121.454 173.947 121.454 144.032V138.481H83.6546V102.703H167.304V224.218H132.295L130.436 190.602C122.693 214.659 103.791 229.464 75.5989 229.464C26.9526 229.464 0 193.686 0 112.573Z"
        fill="#97D9EB"
      />
      <path
        d="M304.416 173.661H243.795L231.423 224.834H183.174L245.026 4.62805H303.479L365.025 224.834H316.776L304.405 173.661H304.416ZM296.062 139.236L280.598 74.4162C278.43 64.1838 276.267 55.4938 274.412 42.7801H273.793C272.244 55.4938 270.082 64.1782 267.607 74.4162L252.143 139.236H296.057H296.062Z"
        fill="#FF9800"
      />
      <path
        d="M380.896 4.63364H446.523L475.622 129.311C478.099 140.477 479.644 150.709 480.263 158.773H481.194C481.813 150.709 483.364 140.164 485.835 128.998L514.314 4.62805H579.941V224.834H537.222V94.2606C537.222 81.234 537.529 65.1059 538.148 52.0793H537.222C536.29 60.4563 534.745 69.1351 532.888 79.0601L499.149 224.828H461.07L426.399 79.0601C424.229 69.1351 422.378 58.2768 422.065 52.3866H420.827C421.759 64.7929 421.759 80.9211 421.759 94.255V224.828H380.896V4.63364Z"
        fill="#FF4D44"
      />
      <path
        d="M731.375 188.547V224.834H603.748V4.62805H729.22V40.9145H651.53V93.9499H724.592V129.929H651.53V188.547H731.375Z"
        fill="#6041FF"
      />
      <path
        d="M739.976 167.477L781.992 148.971C789.094 177.652 801.764 191.223 824.007 191.223C840.996 191.223 850.882 181.048 850.882 165.932C850.882 150.816 845.009 142.491 826.785 136.939L795.273 127.069C764.073 117.199 749.551 94.6809 749.551 63.8431C749.551 23.7466 780.133 0 823.384 0C862.928 0 891.038 16.0386 900 55.5181L861.074 74.9467C854.895 47.8045 840.373 35.7783 821.53 35.7783C805.465 35.7783 795.268 45.0314 795.268 58.9081C795.268 72.7849 803.3 81.7322 820.601 87.5897L852.112 98.0764C884.859 109.18 898.141 128.609 898.141 161.303C898.141 201.088 870.337 229.464 822.148 229.464C777.661 229.464 750.168 207.257 739.971 167.471L739.976 167.477Z"
        fill="#FFA1E1"
      />
    </svg>
  );
}
